import { render, staticRenderFns } from "./LayerPreviewImage.vue?vue&type=template&id=587a6608&"
import script from "./LayerPreviewImage.vue?vue&type=script&lang=js&"
export * from "./LayerPreviewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports